import { useToastNotificationContext } from './useToastNotification';

import DialogAlertWithTrigger from '~/features/shared/toast-notifications/AlertWithTrigger';
import ConfirmationModal from '~/features/shared/toast-notifications/ConfirmationModal';
import ErrorToastAlert from '~/features/shared/toast-notifications/ErrorToastWithTrigger';
import ToastAlert from '~/features/shared/toast-notifications/ToastAlert';

const ToastNotification = () => {
  const {
    toast,
    removeToastHandler,
    alertModal,
    closeAlertModal,
    errorToast,
    closeErrorToast,
    openSubmitErrorTicket,
    confirmationModal,
    closeConfirmationModal,
    callConfirmationTrigger,
  } = useToastNotificationContext();

  return (
    <>
      {toast.open && (
        <ToastAlert
          open={toast.open}
          setOpen={removeToastHandler}
          message={toast.message}
          severity={toast.severity}
          duration={errorToast?.open ? 1000 : 2500} // check if errorToast will show to avoid showing ToastAlert
        />
      )}
      {alertModal.open && (
        <DialogAlertWithTrigger
          open={alertModal.open}
          handleClose={closeAlertModal}
          headerText={alertModal.headerText}
          alertText={alertModal.alertText}
        />
      )}
      {errorToast?.open && !toast.open && (
        <ErrorToastAlert
          open={errorToast.open}
          handleClose={closeErrorToast}
          alertText={errorToast.message}
          submitError={openSubmitErrorTicket}
        />
      )}

      {confirmationModal.open && (
        <ConfirmationModal
          open={confirmationModal.open}
          callTrigger={callConfirmationTrigger}
          handleClose={closeConfirmationModal}
          headerText={confirmationModal.headerText}
          alertText={confirmationModal.alertText}
          buttonText1={confirmationModal.buttonText1}
          buttonText2={confirmationModal.buttonText2}
        />
      )}
    </>
  );
};

export default ToastNotification;
